const LAST_RESTAURANT_KEY = 'peppar_last_restaurant_app';

export function saveLastRestaurantAppName(appName: string): void {
  const trimmed = appName?.trim();
  if (!trimmed) return;
  try {
    sessionStorage.setItem(LAST_RESTAURANT_KEY, trimmed);
  } catch {
    // ignore quota / private mode
  }
}

export function getLastRestaurantAppName(): string | null {
  try {
    return sessionStorage.getItem(LAST_RESTAURANT_KEY);
  } catch {
    return null;
  }
}

export function resolveRestaurantAppName(currentAppName: string | null): string | null {
  return currentAppName ?? getLastRestaurantAppName();
}
